exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-page-loader[data-v-5e152b40]{background:rgba(0,0,0,.16);position:absolute;left:0;top:0;width:100%}", ""]);

// exports
